<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="450px"
    :close-on-click-modal="false"
    @close="$router.replace('/app-versions')"
  >
    <el-form
      ref="appVersionForm"
      v-loading="loading"
      :model="appVersion"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="version"
        label="Verzió"
      >
        <el-input
          v-model="appVersion.version"
        />
      </el-form-item>
      <el-form-item
        prop="file"
        label="Fájl"
      >
        <el-upload
          drag
          action=""
          :auto-upload="false"
          :on-change="handleFileChange"
          :file-list="fileList"
          :limit="1"
          :on-exceed="handleError"
          :on-remove="handleRemove"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Húzd ide a fájlt vagy <em>kattints a feltöltéshez</em></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/users/categories')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'appVersionId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        appVersion: {},
        fileList: [],
        source: null,
        file: {
          file: {}
        },
        rules: {
          version: [
            { required: true, message: 'Mező megadása kötelező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új app verzió';
        } else if (this.type === 'update') {
          return 'App verzió módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      if (this.appVersionId) {
        this.appVersion = await this.$store.dispatch('appVersion/fetch', this.appVersionId);
      } else {
        this.appVersion.availableParents = this.$store.getters['appVersion/appVersions'];
      }
      this.loading = false;
    },
    methods: {
      async handleFileChange(file) {
        if (this.isFileCorrect(file)) {
          this.file.file.path = URL.createObjectURL(file.raw);
          this.source = file.raw;
          this.file.file_size = file.raw.size;
          this.file.file_extension = file.name.split('.').pop();
        } else {
          this.fileList = [];
        }
      },
      handleError(files) {
        this.$messageWrapper.warning('Egyszerre egy fájl adható hozzá');
      },
      handleRemove(file) {
        this.fileList = [];
        this.file = {
          file: {},
        };
      },
      isFileCorrect(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isLt2M) {
          this.$messageWrapper.error('Fajl mérete nem lehet nagyobb, mint 10MB!');
          return isLt2M;
        }
        return isLt2M;
      },
      async store() {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        this.$refs['appVersionForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              const formData = new FormData();
              formData.append('version', this.appVersion.version);
              formData.append('file', this.source);
              if (this.type === 'add') {
                await this.$store.dispatch('appVersion/create', { data: formData, config });
              } else if (this.type === 'update') {
                await this.$store.dispatch('appVersion/update', { data: formData, config });
              }
              this.$store.dispatch('appVersion/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/app-versions');
            } catch (e) {
              console.log(e);
            }
            this.buttonLoading = false;
          }
        });
      },
      async uploadFiles(productId) {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        if (this.product.files.length) {
          for(let [idx, file] of this.product.files.entries()) {
            let formData = new FormData();
            formData.append('product_id', productId);
            formData.append('description', file.description || '');
            if (!file.id) {
              formData.append('file', file.source);
            }
            if (file.id) {
              formData.append('id', file.id);
            }
            await axios.post('api/file-upload', formData, config);
          }
        }
      },
    },
  };
</script>
